var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhitePayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "8px",
    viewBox: "0 0 15 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDownWhitePayment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.1087924,3.94867422 C11.1232012,4.18342476 11.0454599,4.42273072 10.8755686,4.60832446 L5.34168941,10.653679 C5.06191975,10.9593067 4.58736141,10.9802688 4.28173371,10.7004991 C4.26544556,10.685589 4.24982364,10.6699671 4.23491358,10.653679 C3.92169547,10.3115113 3.92169547,9.78677573 4.23491358,9.44460807 L9.26585655,3.94867422 L4.23491358,-1.54725962 C3.92169547,-1.88942728 3.92169547,-2.41416286 4.23491358,-2.75633052 C4.51468324,-3.06195823 4.98924157,-3.08292032 5.29486928,-2.80315065 C5.31115743,-2.78824059 5.32677935,-2.77261867 5.34168941,-2.75633052 L10.8755686,3.28902399 C11.0454599,3.47461772 11.1232012,3.71392368 11.1087924,3.94867422 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowDownWhitePayment",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(7.555241, 3.948674) rotate(90.000000) translate(-7.555241, -3.948674) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhitePayment);
export default __webpack_public_path__ + "static/media/arrowDownWhitePayment.6e0421d15ce3924fd33f04e0e3298233.svg";
export { ForwardRef as ReactComponent };